import React, { useState } from "react";
import {
  Box,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import { StudentExportTypeEnum } from "../../students/const";
import { AssignmentReportTypeEnum } from "../../assignments/const";
import { ExportTypeEnum } from "../const";

const useStyles = makeStyles({
  alertAvailableExportTypeFirstChild: {
    paddingLeft: 20,
  },
  alertCollapsableButtonContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  alertCollapsableButton: {
    color: "rgb(13, 60, 97)",
    padding: "0px",
    backgroundColor: "transparent",
  },
  alertCollapsableComponent: {
    marginTop: 2,
    paddingLeft: 20,
  }
});

const ExportTypeInformationComponent = () => {
  const classes = useStyles();

  const [optionalOpen, setOptionalOpen] = useState<any>({});
  const toggleOptional = (index: string) => {
    setOptionalOpen((prev: any) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <Alert severity="info">
      <Typography variant="subtitle1" gutterBottom>
        <strong>Available Export Types:</strong>
      </Typography>

      <ol className={classes.alertAvailableExportTypeFirstChild}>
        {/* Parent Data */}
        <li>
          <Typography variant="body1">
            <strong>Parent Data</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: Parent ID, Parent Name, Student ID, Student Name, Contact No, Email,
            School Code, MBC Customer ID, Outstanding Amount.
          </Typography>
        </li>

        {/* Student Data */}
        <li>
          <Typography variant="body1">
            <strong>Student Data</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: School Code, Student ID, Student External ID, Student Name, Gender, Grade, Class, Student Status, Student main Address
          </Typography>

          {/* Optional filters and toggles under students data*/}
          <Box className={classes.alertCollapsableButtonContainer}>
            <Typography variant="body2" gutterBottom>
              <strong>Optional filters and toggles</strong>:
            </Typography>
            <Tooltip title={`Click to ${optionalOpen[StudentExportTypeEnum.Student] ? "hide" : "show"} the optional filters and toggles section`}>
              <IconButton
                className={classes.alertCollapsableButton}
                onClick={() => toggleOptional(StudentExportTypeEnum.Student)}
                size="small"
              >
                {optionalOpen[StudentExportTypeEnum.Student] ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={optionalOpen[StudentExportTypeEnum.Student]}>
            <ul className={classes.alertCollapsableComponent}>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Registration Date: Retrieve students by selected date range
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Status: Retrieve students by selected status
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Parent Information: Adds Parent ID, Parent Name,
                  MBC Customer ID, Parent Contact, Parent Email, Parent Status
                  (optional: Guardian Name, Guardian Relationship, Guardian Contact, Guardian Email)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Student Schedule: Adds Academic Year/Name,
                  Academic Term ID/Name, CCA Academic Year ID/Name, CCA Academic Term ID/Name,
                  Is Taking, Schedule Type, Schedule, Date Period, Pickup & Drop-off Address,
                  CCA Drop Off Address, Days of Week (optional: Estimated Revenue)
                </Typography>
                <ul className={classes.alertCollapsableComponent}>
                  <li>
                    <Typography variant="body2" gutterBottom>
                      Filter Student Schedule by Term: Retrieve student schedules by selected academic terms.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2" gutterBottom>
                      Filter Student Schedule by CCA Term: Retrieve CCA student schedules by selected CCA academic terms.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Route Plan: Adds Route Type, Route Name, Route Start Time,
                  Route End Time, Route Address, Route Estimated Arrive Time, Route Order, Route Remarks
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Subsidy Setting: Adds Student Subsidy Period, Student Subsidy Percentage
                </Typography>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* Student Master List */}
        <li>
          <Typography variant="body1">
            <strong>Student Master List</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: School Code, Student ID, Student Name, Gender, Grade, Class, Student Status, Student main Address,
            Academic Year/Name, Academic Term ID/Name, CCA Academic Year ID/Name, CCA Academic Term ID/Name,
            Is Taking, Schedule Type, Schedule, Date Period, Pickup & Drop-off Address,
            CCA Drop Off Address, Days of Week, Estimated Revenue, Route Type, Route Name, Route Start Time,
            Route End Time, Route Address, Route Estimated Arrive Time, Route Order, Route Remarks,
            Parent ID, Parent Name, MBC Customer ID, Parent Contact, Parent Email, Parent Status
            (optional: Guardian Name, Guardian Relationship, Guardian Contact, Guardian Email)
          </Typography>

          {/* Optional filters and toggles under students data*/}
          <Box className={classes.alertCollapsableButtonContainer}>
            <Typography variant="body2" gutterBottom>
              <strong>Optional filters</strong>:
            </Typography>
            <Tooltip title={`Click to ${optionalOpen[StudentExportTypeEnum.StudentMasterList] ? "hide" : "show"} the optional filters section`}>
              <IconButton
                className={classes.alertCollapsableButton}
                onClick={() => toggleOptional(StudentExportTypeEnum.StudentMasterList)}
                size="small"
              >
                {optionalOpen[StudentExportTypeEnum.StudentMasterList] ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={optionalOpen[StudentExportTypeEnum.StudentMasterList]}>
            <ul className={classes.alertCollapsableComponent}>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Registration Date: Retrieve students by selected date range
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Status: Retrieve students by selected status
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter Student Schedule by Term: Retrieve student schedules by selected academic terms.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter Student Schedule by CCA Term: Retrieve CCA student schedules by selected CCA academic terms.
                </Typography>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* Assignment Area report */}
        <li>
          <Typography variant="body1">
            <strong>Assigment Area Report</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: Route Name, Total Student for each Area
          </Typography>
        </li>

        {/* Assignment Passenger report */}
        <li>
          <Typography variant="body1">
            <strong>Assigment Passenger Report</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: School Name, Assignment Date, Assignment ID, Route Name, Wave Name, Route Type,
            Estimated Arrived At, Student Name, Boarded At, Alighted At
          </Typography>

          {/* Optional filters under assignment passenger report*/}
          <Box className={classes.alertCollapsableButtonContainer}>
            <Typography variant="body2" gutterBottom>
              <strong>Optional filter</strong>:
            </Typography>
            <Tooltip title={`Click to ${optionalOpen[AssignmentReportTypeEnum.PassengerReport] ? "hide" : "show"} the optional filters section`}>
              <IconButton
                className={classes.alertCollapsableButton}
                onClick={() => toggleOptional(AssignmentReportTypeEnum.PassengerReport)}
                size="small"
              >
                {optionalOpen[AssignmentReportTypeEnum.PassengerReport] ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={optionalOpen[AssignmentReportTypeEnum.PassengerReport]}>
            <ul className={classes.alertCollapsableComponent}>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter Assigment Passenger Report by Wave: Retrieve assigment passenger
                  report by selected wave
                </Typography>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* Assignment AM Bus Arrival report */}
        <li>
          <Typography variant="body1">
            <strong>Assignment AM Bus Arrival Report</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: Assignment ID, Wave Name, Route Name, Vehicle No, Driver, Bus Assistant, Assignment Date
            Estimated Arrival Time to School, Actual Arrival Time to School, Arrival Status
          </Typography>

          {/* Optional filters under AM bus arrival report*/}
          <Box className={classes.alertCollapsableButtonContainer}>
            <Typography variant="body2" gutterBottom>
              <strong>Optional filter</strong>:
            </Typography>
            <Tooltip title={`Click to ${optionalOpen[AssignmentReportTypeEnum.AmBusArrivalReport] ? "hide" : "show"} the optional filters section`}>
            <IconButton
              className={classes.alertCollapsableButton}
              onClick={() => toggleOptional(AssignmentReportTypeEnum.AmBusArrivalReport)}
              size="small"
            >
              {optionalOpen[AssignmentReportTypeEnum.AmBusArrivalReport] ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={optionalOpen[AssignmentReportTypeEnum.AmBusArrivalReport]}>
            <ul className={classes.alertCollapsableComponent}>
              <li>
                <Typography variant="body2" gutterBottom>
                  Download All AM Waves within Date Range: Retrieve AM bus arrival
                  report by selected AM waves or all AM waves
                </Typography>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* Assignment Summary report */}
        <li>
          <Typography variant="body1">
            <strong>Assignment Summary Report</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: Wave Name, Total Trip, Trip Started, Trip Ended, Trip Ready, Bus On Time, Bus Late
          </Typography>
        </li>

        {/* Commercial Document Data */}
        <li>
          <Typography variant="body1">
            <strong>Commercial Document Data</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Columns: Commercial Document ID, MBC Ref, Issued Date, Status, Description, Amount,
            Amount Include VAT, User ID, School MBC Code
          </Typography>

          {/* Optional filters and toggles under students data*/}
          <Box className={classes.alertCollapsableButtonContainer}>
            <Typography variant="body2" gutterBottom>
              <strong>Optional filters and toggles</strong>:
            </Typography>
            <Tooltip title={`Click to ${optionalOpen[ExportTypeEnum.CommercialDocument] ? "hide" : "show"} the optional filters and toggles section`}>
              <IconButton
                className={classes.alertCollapsableButton}
                onClick={() => toggleOptional(ExportTypeEnum.CommercialDocument)}
                size="small"
              >
                {optionalOpen[ExportTypeEnum.CommercialDocument] ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={optionalOpen[ExportTypeEnum.CommercialDocument]}>
            <ul className={classes.alertCollapsableComponent}>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Status: Retrieve documents by selected status
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by School MBC Code: Retrieve documents by specific school
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Filter by Description: Retrieve documents by partial description
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Parent Information: Adds Parent ID, Parent Name,
                  MBC Customer ID, Parent Contact, Parent Email
                  (optional: Guardian Name, Guardian Relationship, Guardian Contact, Guardian Email)
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Include Student Information: Adds Student ID, Student External ID, Student Name
                  (optional: Academic Year ID/Name, Academic Term ID/Name, CCA Academic Year ID/Name,
                  CCA Academic Term ID/Name, Is Taking, Schedule Type, Schedule, Date Period, Pickup & Drop Off Address,
                  CCA Drop-off Address, Days of Week)
                </Typography>
              </li>
            </ul>
          </Collapse>
        </li>
      </ol>
    </Alert>
  )
}

export default ExportTypeInformationComponent;